import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// Import i18next configuration and wait for initialization
import { i18nextInitialized } from './i18next.js'

// Import Bootstrap and jQuery
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import $ from 'jquery'

// Make jQuery available globally for Bootstrap
window.jQuery = window.$ = $

// Log environment information
if (process.env.NODE_ENV === 'development') {
  console.log('Running in development mode')
}

// Create the Vue application
const app = createApp(App)

// Use router
app.use(router)

// Add a loading indicator to the page
const loadingIndicator = document.createElement('div')
loadingIndicator.id = 'i18n-loading'
loadingIndicator.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.8); display: flex; justify-content: center; align-items: center; z-index: 9999;'
loadingIndicator.innerHTML = '<div style="text-align: center;"><div class="spinner-border text-primary" role="status"></div><p style="margin-top: 10px;">Loading translations...</p></div>'
document.body.appendChild(loadingIndicator)

// Wait for i18next to initialize before mounting the app
i18nextInitialized
  .then(() => {
    // Remove the loading indicator
    const indicator = document.getElementById('i18n-loading')
    if (indicator) {
      indicator.remove()
    }
    
    // Mount the app
    app.mount('#app')
  })
  .catch(error => {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to initialize i18next:', error)
    }
    
    // Even on error, we should mount the app to provide some functionality
    // and give error feedback to the user
    const indicator = document.getElementById('i18n-loading')
    if (indicator) {
      indicator.remove()
    }
    
    app.mount('#app')
  })
